import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  showMaster = false;
  showEmployees = false;
  isMasterExpanded = false;
isEmployeeExpanded = false;
isSettingsExpanded = false;
public isItFacilityExpanded = false;
public isMicrosoftexpanded=false;
public isTicketexpanded=false;
public isITRevokeexpanded=false;
public menuList: any[] = [];

  toggleMaster() {
    // this.showMaster = !this.showMaster;
    // if(this.isMasterExpanded){
    //   this.isMasterExpanded = false;
    // }
    // else if(this.isEmployeeExpanded){
    //   this.isEmployeeExpanded = false;
    // }else if(this.isItFacilityExpanded){
    //   this.isItFacilityExpanded = false;
    // }else if(this.isMicrosoftexpanded){
    //   this.isMicrosoftexpanded = false;
    // }else if(this.isTicketexpanded){
    //   this.isTicketexpanded = false;  }
    //   else if(this.isITRevokeexpanded){
    //     this.isITRevokeexpanded=false;
    //   }
  }
   parseSqlJsonString(text: string): any[] {
  try {
    const fixedJson = text
      .replace(/([{,])\s*([A-Za-z0-9_]+)\s*:/g, '$1"$2":')   // quote keys
      .replace(/:\s*([^,"\[\]\{\}]+)/g, ':"$1"');           // quote values

    return JSON.parse(fixedJson);
  } catch (e) {
    console.error('JSON parse error:', e);
    return [];
  }
}
  public Menustate:any={};
 parseChildren(children: any[]): any[] {
  return children.map(child => {
    const parsedChild = {
      ...child,
      children: Array.isArray(child.Children)
        ? this.parseChildren(child.Children)
        : []
    };

    // Initialize menu state
    if (child.menuKey) {
      this.Menustate[child.menuKey] = true;
    }

    return parsedChild;
  });
}


toggleMenu(key: string) {
  console.log('Clicked:', key);
  for (const k in this.Menustate) {
    if (k !== key) this.Menustate[k] = true;
  }
  this.Menustate[key] = !this.Menustate[key];
}
normalizeMenus(menus: any[] = []): any[] {
  if (!Array.isArray(menus)) {
    return [];
  }

  return menus.map(menu => {
    let children = [];

    
    if (typeof menu.Children === 'string') {
      try {
        children = JSON.parse(menu.Children);
      } catch {
        children = [];
      }
    } else if (Array.isArray(menu.Children)) {
      children = menu.Children;
    }

    return {
      ...menu,
      Children: this.normalizeMenus(children)
    };
  });
}
public status:string='';
 loadMenus() {
  this.appservice
    .getTable("api/Transaction/GetMenuDetails?Rights=" + this.appservice.Rights)
    .subscribe((res: any) => {

      if (typeof res === 'string') {
      this.menuList = JSON.parse(res).record;
    } 
    else if (res?.length && typeof res[0] === 'string') {
    
      this.menuList = JSON.parse(res.record[0]);
    }
    else {
      this.menuList = res;
    }

    if (!Array.isArray(this.menuList)) {
      this.menuList = [];
      return;
    }
console.log("the menu list",this.menuList);
  
   this.menuList.forEach(menu => {
  if (menu.Children && typeof menu.Children === 'string') {
    menu.Children = this.parseSqlJsonString(menu.Children);
  } else {
    menu.Children = [];
  }

 this.menuList.forEach(menu => {
  menu.expanded = false;
}); 
    });
  });
}

toggle(selectedMenu: any) {
  this.menuList.forEach(menu => {
    menu.expanded = menu === selectedMenu ? !menu.expanded : false;
  });
  console.log("the selected menu",selectedMenu,this.menuList);
}
toggleMenu1(selectedMenu: any) {
  this.menuList.forEach(menu => {
    menu.expanded = menu === selectedMenu ? !menu.expanded : false;
  });

  console.log('selected menu:', selectedMenu.MM_Display_Name);
}
  toggleItFacility() {
    this.isItFacilityExpanded = !this.isItFacilityExpanded;
    if(this.isMasterExpanded){
      this.isMasterExpanded = false;
    }
    else if(this.isEmployeeExpanded){
      this.isEmployeeExpanded = false;
    }else if(this.showMaster){
      this.showMaster = false;
    }else if(this.isMicrosoftexpanded){
      this.isMicrosoftexpanded = false;
    }else if(this.isTicketexpanded){
      this.isTicketexpanded = false;  }
  }
logout(){
  this.router.navigate(['/login']);
}
  toggleEmployees() {
    this.showEmployees = !this.showEmployees;
  }
  constructor(public appservice:AppService,public router:Router) { }

  ngOnInit(): void {
    this.appservice.getreferencegroupvalues();
    this.loadMenus();
  }

}
